import { GeneralService } from './../../../../core/services/general.service';
import { Component, OnInit } from '@angular/core';
import { Activo } from '../../../../core/modelos/activo';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ActivosService } from '../activos.service';
import { Sector } from '../../../../core/modelos/sector';
import { Tipologia } from '../../../../core/modelos/tipologia';
import { Estado } from '../../../../core/modelos/estado';
import { Cliente } from '../../../../core/modelos/cliente';
import { fuseAnimations } from '../../../../core/animations';
import { NotificacionesService } from '../../../../core/notificaciones/notificaciones.service';
import { FileManagerService } from '../../file-manager/file-manager.service';
import { User } from '../../../../core/modelos/user';
import { Sociedad } from '../../../../core/modelos/sociedad';

@Component({
    selector: 'fuse-activos-editar',
    templateUrl: './activos-editar.component.html',
    styleUrls: ['./activos-editar.component.scss'],
    animations: fuseAnimations
})
export class ActivosEditarComponent implements OnInit {

    activo: Activo;
    idActivo: number;

    // Variable que indica si estamos editando o creando.
    editando = false;
    loading = true;

    // Validación del servidor
    validacion: any;

    // Formulario
    formulario: FormGroup;

    sectores: Sector[];
    sectorId: number;
    tipologias: Tipologia[];
    estados: Estado[];
    clientes: Cliente[];
    sociedades: Sociedad[];

    ocultar = true;

    selectedFiles: FileList;
    imagen;
    usuarioLogueado: User;

    esAdminBod: boolean;

    linkPattern: RegExp = /^https?:\/\/.+$/;
    // coordPattern: RegExp = /^(\-?\d+(\.\d+)?).\s*(\-?\d+(\.\d+)?)$/;
    latPattern: RegExp = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/;
    lonPattern: RegExp = /^\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private activosService: ActivosService,
        private generales: GeneralService,
        private notificaciones: NotificacionesService,
        private fileManagerService: FileManagerService
    ) {
        // Traigo el activo por parametro
        this.activatedRoute.params.subscribe(params => {
            this.idActivo = params['idActivo'];

            // notify about the new activo
            this.activosService.setCurrentActivo(this.idActivo)
        });

        // Guardo los sectores
        this.getSectores();

        // Guardo tipologías
        // this.getTipologias();

        // Guardo estados
        this.getEstados();
        // Guardo estados
        this.getClientes();
        // Guardo estados
        this.getSociedades();
    }

    ngOnInit() {

        this.init();

    }

    init() {

        this.usuarioLogueado = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;

        this.esAdminBod = this.usuarioLogueado.rol.id === 1;

        if (this.idActivo) {
            this.editando = true;
            this.getActivo(this.idActivo); // TODO: Suscribir para redirigir si no existe

        } else {
            // console.log('añadiendo...');
            this.loading = false;
            this.crearFormulario();
        }
    }

    getActivo(id: number) {
        this.activosService.getActivo(id).subscribe(
            data => {
                if (data.success) {
                    this.activo = data.items;
                    this.activo.imagen = this.activo.imagen ? 'data:image/jpeg;base64,' + this.activo.imagen : null;
                    this.loading = false;
                    this.crearFormulario();

                    // Guardo tipologías
                    this.getTipologias(this.activo.sector.id);

                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoNOObtenido);
                    this.router.navigate(['/activos']);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    crearFormulario() {
        if (this.editando) {
            this.formulario = this.fb.group({
                nombre: [this.activo.nombre, Validators.required],
                codigo: [this.activo.codigo, Validators.required],
                ciudad: [this.activo.ciudad, Validators.required],
                direccion: [this.activo.direccion, Validators.required],
                estado: [this.activo.estado, Validators.required],
                enlace: [this.activo.enlace, [Validators.required, Validators.pattern(this.linkPattern)]],
                latitud: [this.activo.latitud, [Validators.required, Validators.pattern(this.latPattern)]],
                longitud: [this.activo.longitud, [Validators.required, Validators.pattern(this.lonPattern)]],
                sector: [this.activo.sector, Validators.required],
                tipologia: [this.activo.tipologia, Validators.required],
                sociedad: [this.activo.sociedad, Validators.required],
                descripcion: [this.activo.descripcion, Validators.required]
            });
        } else {
          if (this.usuarioLogueado.rol.id === 1) {
            this.formulario = this.fb.group({
              nombre: ['', Validators.required],
              codigo: ['', Validators.required],
              ciudad: ['', Validators.required],
              direccion: ['', Validators.required],
              estado: ['', Validators.required],
              enlace: ['', Validators.required],
              latitud: ['', Validators.required],
              longitud: ['', Validators.required],
              sector: ['', Validators.required],
              tipologia: ['', Validators.required],
              sociedad: ['', Validators.required],
              descripcion: ['', Validators.required]
            });
          } else {
              this.formulario = this.fb.group({
                nombre: ['', Validators.required],
                codigo: ['', Validators.required],
                ciudad: ['', Validators.required],
                direccion: ['', Validators.required],
                estado: ['', Validators.required],
                enlace: ['', Validators.required],
                latitud: ['', Validators.required],
                longitud: ['', Validators.required],
                sector: ['', Validators.required],
                tipologia: ['', Validators.required],
                sociedad: ['', Validators.required],
                descripcion: ['', Validators.required]
              });
            }
        }
    }

    compare(val1, val2) {
        return val1.id === val2.id;
    }

    cambiosSector(event: any) {

        // Actualiza tipologías
        this.getTipologias(event.value.id);
    }

    actualizarPag(event: boolean) {
        if (event) {
            this.init();
        }
    }
    selectFile(event) {
        // Recoge la imagen que quiere subir el usuario y la guardo en this.imagen con el formato adecuado
        this.selectedFiles = event.target.files;
        const reader = new FileReader();
        const file = this.selectedFiles.item(0);
        if (file.size > 512000) {
            event = null;
            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.FotoGrande);
        }
        else if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
            event = null;
            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.TipoFotoNoValida);
        }
        else {
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.imagen = (<any>reader.result).split(',')[1];
                this.activo.imagen = 'data:image/jpeg;base64,' + this.imagen; // Para que actualice en pantalla también
                event = null;

            };
        }



    }

    onSubmit(): void {
        this.loading = true;
        this.activo = this.prepararModelo();
        this.activo.imagen = this.imagen;
        if (this.editando) {

            /*
            var oldCarpetaAWS: string = null;
            if (this.activo.carpetaAWS != this.activo.codigo) {
                oldCarpetaAWS = this.activo.carpetaAWS;
                this.activo.carpetaAWS = this.activo.codigo;
            }
            */

            this.activosService.updateActivo(this.activo).subscribe(
                data => {
                    if (data.success) {
                        // this.activosService.removeAssetsFromCache();
                        // this.router.navigate(['/activos/detalle', data.items.id]);
                        // this.init();
                        /*
                        if (oldCarpetaAWS) {
                            // Mueve la carpeta del activo
                            try {
                                this.fileManagerService.moveObject(oldCarpetaAWS, this.activo.carpetaAWS);
                            }
                            catch(error) {
                                this.notificaciones.mostrarAviso('Error: ' + error);
                            }
                        }
                        */
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoEditado);
                        this.router.navigate(['/activos']);
                    } else if (data.message) {
                        this.validacion = data.message;
                        this.init();
                    }
                    else {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoNOEditado);
                        this.router.navigate(['/activos']);
                    }
                },
                err => {
                    this.notificaciones.errorServidor(err.status);
                    this.router.navigate(['/activos']);
                    // if (err.error.message) {
                    //     this.validacion = err.error.message;
                    // }
                }
            );

        } else {
            // Al añadir un activo, creo una carpeta en el bucket con su nombre
            this.loading = true;
            this.activo.cliente = this.usuarioLogueado.cliente;
            this.activosService.addActivo(this.activo).subscribe(
                data => {
                    this.loading = false;
                    if (data.success) {
                        // this.activosService.removeAssetsFromCache();
                        /*
                        // No creo la carpeta si el activo no ha sido creado
                        this.crearCarpetaActivo(this.activo);
                        */
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoCreado);
                        this.router.navigate(['/activos']);
                        // TODO: Alerta de centro creado
                    } else if (data.message) {
                        this.notificaciones.mostrarAviso(data.message);

                    }
                    else {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoNOCreado);
                        this.router.navigate(['/activos']);
                    }
                },
                error => {
                    this.loading = false;
                    this.notificaciones.errorServidor(error.status);
                    this.router.navigate(['/activos']);
                }
            );
        }


    }

    /*
    crearCarpetaActivo(activo: Activo) {
        this.fileManagerService.newFolder(activo.carpetaAWS).send(function (err) {
            if (!err) {
                // La carpeta asociada al activo también ha sido creada
            }
        });
    }
    */

    prepararModelo(): Activo {
        const formModel = this.formulario.value;


        const saveActivo: Activo = {
            id: this.activo ? this.activo.id : undefined,
            nombre: formModel.nombre,
            codigo: formModel.codigo,
            ciudad: formModel.ciudad,
            direccion: formModel.direccion,
            estado: formModel.estado,
            enlace: formModel.enlace,
            latitud: formModel.latitud,
            longitud: formModel.longitud,
            sector: formModel.sector,
            tipologia: formModel.tipologia,
            kpis: this.activo ? this.activo.kpis : [],
            cliente: formModel.cliente,
            sociedad: formModel.sociedad,
            descripcion: formModel.descripcion,
            carpetaAWS: formModel.codigo
        };

        return saveActivo;
    }

    getSectores() {

        this.generales.getSectores().subscribe(

            data => {
                // console.log(data);
                if (data.success) {
                    this.sectores = data.items;
                    // console.log(this.codPostales);
                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.Sectores.NOObtenidos);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    getTipologias(id: number) {

        this.generales.getTipologias(id).subscribe(

            data => {
                if (data.success) {
                    this.tipologias = data.items;
                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.Tipologias.NOObtenidas);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    getEstados() {

        this.generales.getEstados().subscribe(

            data => {
                if (data.success) {
                    this.estados = data.items;
                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.EstadosProyecto.NOObtenidos);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    getClientes() {

        this.generales.getClientes().subscribe(

            data => {
                if (data.success) {
                    this.clientes = data.items;
                    // Si el usuario tiene más de 1 cliente (es adminBOD), se muestra select para que elija.
                    if (this.clientes.length > 1) {
                        this.ocultar = false;
                    }
                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.Clientes.NOObtenidos);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    getSociedades() {

        this.generales.getSociedades().subscribe(

            data => {
                if (data.success) {
                    this.sociedades = data.items;
                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.Sociedades.NOObtenidos);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/activos/editar/activos-editar.component.ts